import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-outlook-not-logged-in',
    templateUrl: './outlook-not-logged-in.component.html',
    styleUrls: ['./outlook-not-logged-in.component.scss'],
})
export class OutlookNotLoggedInComponent implements OnInit {
    @Input() loginUrl: string;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnInit(): void {}
}
